import AppIcon from 'components/services/AppIcon';
import React from 'react';
import styles from './InvoiceIntegrationStatus.module.scss';

interface Props {
  paid: boolean;
  synced: boolean;
  isAwaitingSync?: boolean;
  logoUrl?: string;
  logoAlt?: string;
  invoiceUrl?: string | null;
}

const InvoiceIntegrationStatus: React.FC<Props> = ({
  synced,
  logoUrl,
  logoAlt,
  isAwaitingSync,
  invoiceUrl,
}) => {
  if (synced && invoiceUrl) {
    return (
      <a href={invoiceUrl} target="_blank" rel="noopener noreferrer" className={styles.container}>
        <span className={styles.billed}>Synced to</span>
        {logoUrl ? <AppIcon className={styles.appIcon} alt={logoAlt} path={logoUrl} /> : null}
      </a>
    );
  }

  if (synced) {
    return (
      <div className={styles.container}>
        <span className={styles.billed}>Synced to</span>
        {logoUrl ? <AppIcon className={styles.appIcon} alt={logoAlt} path={logoUrl} /> : null}
      </div>
    );
  }

  if (isAwaitingSync) {
    return (
      <div className={styles.container}>
        <span>Syncing...</span>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <span>Not synced</span>
    </div>
  );
};

export default InvoiceIntegrationStatus;
